import type { ComponentType } from 'react';

export interface ActionCardProps {
    icon: ComponentType<{ className?: string }>;
    label: string;
    onSelect: () => void;
    disabled?: boolean;
    disabledReason?: string;
}

// Square action tile: icon over a balanced two-line label.
export function ActionCard({
    icon: Icon,
    label,
    onSelect,
    disabled,
    disabledReason
}: ActionCardProps) {
    return (
        <button
            type="button"
            onClick={onSelect}
            disabled={disabled}
            title={disabled ? disabledReason : undefined}
            className={
                disabled
                    ? 'w-[78px] px-2 min-h-[82px] flex flex-col items-center justify-center gap-1.5 py-3 bg-white border border-gray-200 rounded-xl opacity-40 cursor-not-allowed transition-colors flex-shrink-0'
                    : 'w-[78px] px-2 min-h-[82px] flex flex-col items-center justify-center gap-1.5 py-3 bg-white border border-gray-200 rounded-xl hover:border-yellow-300 hover:bg-yellow-50 transition-colors flex-shrink-0'
            }
        >
            <Icon className={disabled ? 'w-5 h-5 text-gray-400' : 'w-5 h-5 text-yellow-600'} />
            <span
                className="text-[11px] font-medium text-gray-700 leading-tight text-center"
                style={{ textWrap: 'balance' }}
            >
                {label}
            </span>
        </button>
    );
}
